export default __webpack_public_path__ + "static/media/icicilambard.02556062.png";